__turbopack_context__.v({
  "label": "VariantSelector-module__1CI3lG__label",
  "root": "VariantSelector-module__1CI3lG__root",
  "variant": "VariantSelector-module__1CI3lG__variant",
  "variants": "VariantSelector-module__1CI3lG__variants",
});
